"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @hidden
 * Represents a value that doesn't exist at the moment, but will exist once a certain transaction
 * has been run
 */

var PostTransactionResolver =
/*#__PURE__*/
function () {
  // eslint-disable-next-line require-jsdoc
  function PostTransactionResolver(resolver) {
    var _this = this;

    _classCallCheck(this, PostTransactionResolver);

    if (!resolver) {
      this.resolver = function () {
        return __awaiter(_this, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", undefined);

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      };

      return;
    }

    this.resolver = resolver;
  }
  /**
   * Run the resolver function and assign its result to this object
   */


  _createClass(PostTransactionResolver, [{
    key: "run",
    value: function run(receipt) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.resolver(receipt);

              case 2:
                result = _context2.sent;
                this.result = result;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return PostTransactionResolver;
}();

exports.PostTransactionResolver = PostTransactionResolver;
/**
 * @hidden
 * Check if a value is of type [[PostTransactionResolver]]
 */

function isPostTransactionResolver(val) {
  return val instanceof PostTransactionResolver;
}

exports.isPostTransactionResolver = isPostTransactionResolver;